export const FEE_ENTITY = {
  ALL: "",
  BUYER: "buyer",
  SELLER: "seller",
};

export const feeEntityLabels = {
  [FEE_ENTITY.ALL]: "All",
  [FEE_ENTITY.BUYER]: "Buyer",
  [FEE_ENTITY.SELLER]: "Seller",
};

export const feeEntityFormOptions = [
  { value: FEE_ENTITY.BUYER, label: feeEntityLabels[FEE_ENTITY.BUYER] },
  { value: FEE_ENTITY.SELLER, label: feeEntityLabels[FEE_ENTITY.SELLER] },
];

export const feeEntityFilters = [
  { value: FEE_ENTITY.ALL, label: feeEntityLabels[FEE_ENTITY.ALL] },
  { value: FEE_ENTITY.BUYER, label: feeEntityLabels[FEE_ENTITY.BUYER] },
  { value: FEE_ENTITY.SELLER, label: feeEntityLabels[FEE_ENTITY.SELLER] },
];
